import { api } from '../../service/api';
import { DEVICE_PATH, DEVICES_TYPES_PATH } from '../../service/path';
import { showErrorMessage, showSuccessMessage } from '../../utils/utils';

// Action Types
export const GET_DEVICES_REQUEST = 'GET_DEVICES_REQUEST';
export const GET_DEVICES_SUCCESS = 'GET_DEVICES_SUCCESS';
export const GET_DEVICES_FAILURE = 'GET_DEVICES_FAILURE';

export const CREATE_DEVICE = 'CREATE_DEVICE';
export const UPDATE_DEVICE = 'UPDATE_DEVICE';
export const DELETE_DEVICE = 'DELETE_DEVICE';

// Agregar estos tipos de acción
export const UPDATE_DEVICE_REQUEST = 'UPDATE_DEVICE_REQUEST';
export const UPDATE_DEVICE_SUCCESS = 'UPDATE_DEVICE_SUCCESS';
export const UPDATE_DEVICE_FAILURE = 'UPDATE_DEVICE_FAILURE';

// Agregar los nuevos tipos de acción
export const GET_TYPES_DEVICES_REQUEST = 'GET_TYPES_DEVICES_REQUEST';
export const GET_TYPES_DEVICES_SUCCESS = 'GET_TYPES_DEVICES_SUCCESS';
export const GET_TYPES_DEVICES_FAILURE = 'GET_TYPES_DEVICES_FAILURE';

// Agregar nuevos tipos de acción
export const GET_DEVICES_BY_ESTABLISHMENT_REQUEST = 'GET_DEVICES_BY_ESTABLISHMENT_REQUEST';
export const GET_DEVICES_BY_ESTABLISHMENT_SUCCESS = 'GET_DEVICES_BY_ESTABLISHMENT_SUCCESS';
export const GET_DEVICES_BY_ESTABLISHMENT_FAILURE = 'GET_DEVICES_BY_ESTABLISHMENT_FAILURE';

// Action Creators
export const getDevices = () => (dispatch) => {
    dispatch({ type: GET_DEVICES_REQUEST });
    return api.get(DEVICE_PATH)
        .then(response => {
            dispatch({
                type: GET_DEVICES_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch({
                type: GET_DEVICES_FAILURE,
                payload: error.message
            });
        });
};

export const createDevice = (data, callback) => (dispatch) => {
    return api.post(DEVICE_PATH, data)
        .then(response => {
            dispatch({
                type: CREATE_DEVICE,
                payload: response.data
            });
            showSuccessMessage('El dispositivo fue creado correctamente', dispatch);
            if (callback) callback();
        })
        .catch(error => {
            showErrorMessage(error.response?.data?.message || 'Error al crear dispositivo', dispatch);
        });
};

export const updateDevice = (id, data, callback) => async (dispatch) => {
    try {
        dispatch({ type: UPDATE_DEVICE_REQUEST });
        const response = await api.patch(`${DEVICE_PATH}/${id}`, data);
        dispatch({
            type: UPDATE_DEVICE_SUCCESS,
            payload: response.data
        });
        showSuccessMessage('El dispositivo fue actualizado correctamente', dispatch);
        if (callback) callback();
    } catch (error) {
        dispatch({
            type: UPDATE_DEVICE_FAILURE,
            payload: error.message
        });
        showErrorMessage(error.response?.data?.message || 'Error al actualizar dispositivo', dispatch);
    }
};

export const deleteDevice = (id, callback) => (dispatch) => dispatch({
    type: DELETE_DEVICE,
    promise: api.delete(`${DEVICE_PATH}/${id}`),
    meta: {
        onSuccess: () => {
            showSuccessMessage('El dispositivo fue eliminado correctamente', dispatch);
            callback();
        },
        onFailure: (res) => {
            showErrorMessage(res.response.data.message, dispatch);
        }
    }
});

// Agregar la nueva acción para obtener tipos de dispositivos
export const getTypesDevices = () => (dispatch) => {
    dispatch({ type: GET_TYPES_DEVICES_REQUEST });
    return api.get(`${DEVICES_TYPES_PATH}`)
        .then(response => {
            dispatch({
                type: GET_TYPES_DEVICES_SUCCESS,
                payload: response.data
            });
            return response; // Retornamos la respuesta para poder usarla en el componente
        })
        .catch(error => {
            dispatch({
                type: GET_TYPES_DEVICES_FAILURE,
                payload: error.message
            });
            throw error;
        });
};

// Nueva acción para obtener dispositivos por establecimiento
export const getDevicesByEstablishment = (establishmentId) => (dispatch) => {
    dispatch({ type: GET_DEVICES_BY_ESTABLISHMENT_REQUEST });
    return api.get(`/establishment/${establishmentId}/devices`)
        .then(response => {
            dispatch({
                type: GET_DEVICES_BY_ESTABLISHMENT_SUCCESS,
                payload: response.data
            });
            return response;
        })
        .catch(error => {
            dispatch({
                type: GET_DEVICES_BY_ESTABLISHMENT_FAILURE,
                payload: error.message
            });
            showErrorMessage(error.response?.data?.message || 'Error al obtener dispositivos del establecimiento', dispatch);
            throw error;
        });
};
